/**
 * The register's legal forms, in the register's own order.
 *
 * # Why the codes live here and the names live in the locale files
 *
 * The number is the contract — it is what `legal_form` and `exclude_legal_form`
 * carry, and what companies.legal_form holds — so it belongs in code. The words
 * are read by a customer and differ per language, so they belong where every
 * other customer-facing word does.
 *
 * The order is the register's `sort`, which runs commonest-first rather than
 * alphabetically: Einzelunternehmen, Kollektivgesellschaft, AG and GmbH lead,
 * and those four are 92.4% of the corpus. A list sorted by name would open on
 * Aktiengesellschaft and bury Einzelunternehmen in the middle.
 *
 * Generated from the same register table as internal/domain/legalform.go, which
 * is what resolves a name back to one of these numbers.
 */
export const LEGAL_FORM_CODES = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18'
] as const;
